const LIMIT = 100;

export default class History {
  constructor(state) {
    this.snapshot = state;
    this.past = [];
    this.future = [];
    this.key = null;
  }

  record(state, coalesceKey) {
    if (state === this.snapshot) return;

    if (!coalesceKey || coalesceKey !== this.key) {
      this.past.push(this.snapshot);
      this.future = [];

      if (this.past.length > LIMIT) this.past.shift();
    }

    this.key = coalesceKey;
    this.snapshot = state;
  }

  settle() {
    this.key = null;
  }

  undo() {
    return this.#travel(this.past, this.future);
  }

  redo() {
    return this.#travel(this.future, this.past);
  }

  #travel(from, to) {
    if (from.length === 0) return null;

    const state = from.pop();

    to.push(this.snapshot);
    this.snapshot = state;
    this.key = null;

    return state;
  }
}
